<template>
    <app-layout>
        <div class="flex flex-1">
            <app-sidebar></app-sidebar>

            <div class="flex flex-col w-full -mt-5 bg-white shadow-xl rounded-tl-3xl px-9 pt-9">
                <div class="flex items-center mb-8 space-x-5">
                    <div class="text-2xl font-bold text-black">Dashboard</div>
                    <div class="text-sm font-medium text-gray-300">/</div>
                    <div class="text-sm font-medium text-gray-500">Application</div>
                </div><!-- Breadcrumbs -->

                <h2 class="text-[#111827] text-lg font-bold mb-8">Application</h2><!-- Sub Title -->

                <div class="mb-16 rounded-md shadow-normal">
                    <div class="rounded-t-md overflow-hidden flex bg-[#ECECEC]">
                        <template v-for="(tab, index) in tabs" :key="index">
                            <a href="#" @click.prevent="activeTab = tab" class="block w-[204px] py-4 px-5 text-gray-40 text-sm text-center bg-gray-10" :class="{
                                '!text-secondary !bg-white !rounded-t-md !font-bold': tab == activeTab
                            }">
                                <span class="capitalize">{{ tab }}</span>
                            </a>
                        </template>
                    </div><!-- Nav Tabs -->
                    <div class="bg-white rounded-md p-14">
                        <component :is="activeTab + '-tab'" :data="activeTabData"></component>
                    </div><!-- Tab Contents -->
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import AppSidebar from '@/Parts/Sidebar.vue'
import PersonalTab from '@/Pages/Dashboard/PersonalTab.vue'
import SuitabilityTab from '@/Pages/Dashboard/SuitabilityTab.vue'
import InvestmentTab from '@/Pages/Dashboard/InvestmentTab.vue'
import VerificationTab from '@/Pages/Dashboard/VerificationTab.vue'
import { computed, ref } from 'vue'
import { useUrlSearchParams } from '@vueuse/core'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
    components: {
        AppLayout,
        AppSidebar,
        PersonalTab,
        SuitabilityTab,
        InvestmentTab,
        VerificationTab
    },
    props: ['intake'],
    setup(props){
        const queryParams = useUrlSearchParams('history')

        const tabs = ['personal', 'suitability', 'investment', 'verification']

        const activeTab = ref(_.get(queryParams, 'tab', 'personal'))

        const profileData = computed(() => {
            return props.intake.profileForm
        })

        const suitabilityData = computed(() => {
            return props.intake.suitabilityForm
        })

        const investmentData = computed(() => {
            return props.intake.investForm
        })

        const verificationData = computed(() => {
            return props.intake.verificationForm
        })

        const activeTabData = computed(() => {
            if (activeTab.value == 'suitability') {
                return suitabilityData.value
            } else if(activeTab.value == 'investment') {
                return investmentData.value
            } else if(activeTab.value == 'verification') {
                return verificationData.value
            } else {
                return profileData.value
            }
        })

        return {
            tabs,
            activeTab,
            activeTabData
        }
    },
}
</script>

<style>

</style>
